const thousandsSeparator = (number: number | null, hasNoDecimal?: boolean) => {
	if (number === null) {
		return ''
	}

	return hasNoDecimal ? number.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ' ').split('.')[0] : number.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ' ').replace('.', ',')
}

export default thousandsSeparator